import type { CrewStatus } from "@/mocks/admin/crew";

const map: Record<CrewStatus, { label: string; bg: string; text: string; dot: string }> = {
  active: { label: "Active", bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500" },
  off: { label: "Off Today", bg: "bg-ink-100", text: "text-ink-700", dot: "bg-ink-400" },
  "on-leave": { label: "On Leave", bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500" },
  training: { label: "Training", bg: "bg-indigo-50", text: "text-indigo-700", dot: "bg-indigo-500" },
};

export default function CrewStatusBadge({ status }: { status: CrewStatus }) {
  const s = map[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap ${s.bg} ${s.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`}></span>
      {s.label}
    </span>
  );
}